<p-breadcrumb [model]="displayItems()">
  <ng-template #separator>
    <span
      class="mx-2 text-sm leading-5 text-muted"
      aria-hidden="true"
      >›</span
    >
  </ng-template>
  <ng-template
    #item
    let-item
    let-last="last"
  >
    @if (item.id === '__ellipsis__') {
      <!-- Mobile: collapsed parents — click opens the popup menu -->
      <button
        nbxButton
        type="button"
        variant="inline"
        icon="pi pi-ellipsis-h"
        [class]="item.styleClass"
        (click)="toggleMenu($event)"
        (keydown.enter)="toggleMenu($event)"
        (keydown.space)="toggleMenu($event)"
        [attr.aria-label]="'A11Y.MORE_OPTIONS' | transloco"
      ></button>
    } @else if (item.id === '__last__') {
      <!-- Current / last item -->
      <span
        [class]="
          'text-sm leading-5 text-secondary ' +
          (displayItems().length === 1 ? 'font-bold ' : 'font-semibold ') +
          item.styleClass
        "
        >{{ item.label }}</span
      >
    } @else {
      <!-- Parent item -->
      @if (item.routerLink) {
        <a
          [routerLink]="item.routerLink"
          [class]="'text-sm text-secondary cursor-pointer transition-colors ' + item.styleClass"
        >
          {{ item.label }}
        </a>
      } @else {
        <span [class]="'text-sm text-secondary ' + item.styleClass">{{ item.label }}</span>
      }
    }
  </ng-template>
</p-breadcrumb>

<!-- Mobile popup menu with all parent routes -->
<p-menu
  #menu
  [model]="mobileMenuItems()"
  [popup]="true"
  appendTo="body"
/>
